/** Sanitize filename for Supabase storage — alphanumeric, hyphens, underscores. */
export function sanitizeFileName(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.');
    const extension = lastDotIndex > 0 ? fileName.substring(lastDotIndex).toLowerCase() : '';
    const nameWithoutExt = lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;

    const sanitized = nameWithoutExt
        .replace(/\s+/g, '-')
        .replace(/[^a-zA-Z0-9_-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .toLowerCase();

    const finalName = sanitized || 'document';
    return finalName + extension;
}

export function generateStorageFileName(originalFileName: string, userId: string): string {
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').replace('T', '_').split('.')[0];
    const sanitized = sanitizeFileName(originalFileName);
    return `documents/${userId}/${timestamp}_${sanitized}`;
}

/** Path inside the `contracts` bucket from a public object URL (Supabase Storage). */
export function contractsBucketPathFromPublicUrl(publicUrl: string): string | null {
    try {
        const u = new URL(publicUrl);
        const marker = '/storage/v1/object/public/contracts/';
        const idx = u.pathname.indexOf(marker);
        if (idx === -1) return null;
        return decodeURIComponent(u.pathname.slice(idx + marker.length));
    } catch {
        return null;
    }
}
